import React, {useState} from 'react';
import {useParams} from 'react-router-dom';
import {
  Box,
  Button,
  CardContent,
  Checkbox,
  FormControlLabel,
  Grid,
} from '@mui/material';
import {AxiosResponse} from 'axios';
import {useStylesed} from '../../../../../../components/styles/commonStyled';
import DialogApiRequestStatus from '../../../../../../components/dialogs/DialogApiRequestStatus';
import {apiPost} from '../../../../../../axiosConfig';
import {IApiSuccessMsgResponse} from '../../../../../../dto/API.dto';
import {CompanyDetailsList} from '../../../../../../components/onboarding/CompanyDetailsList';
import {broadCastCloseTab} from '../../../../../../react_query/tasks/ListTasks';
import {useTaskContext} from '../../../../../task/TaskContext';

const WelcomeMail = () => {
  const classes = useStylesed();
  const [welcomeCall, setWelcomeCall] = React.useState(false);
  const taskParam = useParams();
  const taskId = Number(taskParam.task_id);
  const {isPreview, companyId} = useTaskContext();
  const [apiState, setApiState] = useState({
    status: '',
    error: null,
    successMsg: '',
  });

  const handleSubmit = React.useCallback(() => {
    setApiState({status: 'pending', error: null, successMsg: ''});
    const payload = {
      welcome_phone_call: welcomeCall,
    };
    apiPost(`v1/task/${taskId}/communication-preference`, payload)
      .then((response: AxiosResponse<IApiSuccessMsgResponse>) => {
        setApiState({
          status: 'success',
          error: null,
          successMsg: response.data.message,
        });
        broadCastCloseTab();
      })
      .catch(error => {
        setApiState({
          status: 'error',
          error,
          successMsg: '',
        });
      });
  }, [welcomeCall, taskId]);

  const handleEdit = () => {
    setApiState({status: '', error: null, successMsg: ''});
  };

  const handleClose = () => {
    setApiState({status: '', error: null, successMsg: ''});
  };

  return (
    <Box className='m-2 blue-variant17 '>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs>
            <CompanyDetailsList
              company_id={companyId}
              taskSlug='partner_success_manager'
            />
          </Grid>
          <Grid item xs>
            <Box my={1} px={1} className={classes.c_start}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={welcomeCall}
                    onChange={() => setWelcomeCall(!welcomeCall)}
                  />
                }
                label='Welcome phone call'
              />
            </Box>
          </Grid>
        </Grid>
      </CardContent>
      <Box className={`${classes.r_end} p-5`}>
        <Button
          variant='contained'
          color='primary'
          onClick={handleSubmit}
          disabled={!welcomeCall || isPreview}>
          Submit
        </Button>
      </Box>
      {apiState.status !== '' && (
        <DialogApiRequestStatus
          apiState={apiState}
          onRetry={() => handleSubmit}
          onEdit={handleEdit}
          onClose={handleClose}
        />
      )}
    </Box>
  );
};

export default WelcomeMail;
